import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
export interface RequestParams {
  /** 设备id */
  device_id: string
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number
  /** 结束时间(unix秒) */
  end_time?: string
  /** 排序: 0-降序(默认) 1-升序 */
  sort?: number
  /** 开始时间(unix秒) */
  start_time?: string
}

export interface List {
  /** 主键 */
  id: string
  /** 经度，空=未获取 */
  longitude: string
  /** 纬度，空=未获取 */
  latitude: string
  /** 获取时间(unix秒) */
  location_time: string
  /** 定位来源: 1-GPS 2-网络定位 3-IP解析 */
  source: number
  /** 外网IP */
  client_ip: string
  /** 定位精度(米)，值越大误差越大，0=未知 */
  accuracy: number
}

export interface ResponseData {
  /** 总数 */
  total: number
  /** 定位日志列表 */
  list?: List[]
}

export interface MatListRequestParams {
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number
  /** 分组筛选，0=全部 */
  group_id?: string
  /** 关键字(设备id/计算机名/用户名) */
  keyword?: string
  /** 指定时刻(unix秒)，0=当前时刻 */
  time?: string
}

export interface MapList {
  /** 设备id */
  device_id: string
  /** 计算机名 */
  computer_name: string
  /** 登记用户名 */
  user_mark: string
  /** 分组名 */
  group_name: string
  /** 经度，空=未获取 */
  longitude: string
  /** 纬度，空=未获取 */
  latitude: string
  /** 定位时间(unix秒) */
  location_time: string
  /** 定位来源: 1-GPS 2-网络定位 3-IP解析 */
  source: number
  /** 外网IP */
  client_ip: string
  /** 在线状态: 1在线 2离线 */
  login_status: number
  /** 定位精度(米)，值越大误差越大，0=未知 */
  accuracy: number
}

export interface MatListResponseData {
  /** 总数 */
  total: number
  /** 位置信息列表 */
  list?: MapList[]
}

export interface TrackRequestParams {
  /** 设备id */
  device_id: string
  /** 结束时间(unix秒) */
  end_time?: string
  /** 密度筛选: 按N分钟采样(0=全部) */
  interval_minute?: number
  /** 开始时间(unix秒) */
  start_time?: string
}

export interface Points {
  /** 经度，空=未获取 */
  longitude: string
  /** 纬度，空=未获取 */
  latitude: string
  /** 定位时间(unix秒) */
  location_time: string
  /** 定位精度(米)，值越大误差越大，0=未知 */
  accuracy: number
}

export interface TrackResponseData {
  /** 轨迹点列表 */
  points?: Points[]
}
@Injectable()
export class LocationInfoService {
  constructor(private http: Http) {
  }
  // 历史列表：单终端时间范围内定位日志
  getLocationHistoryList(data: RequestParams) {
    return this.http.post<ResponseData>('/location/history/list', data)
  }
  // 地图视图：指定时刻各终端最新位置（默认当前时刻）
  getLocationMapList(data: MatListRequestParams) {
    return this.http.post<MatListResponseData>('/location/map/list', data)
  }
  //标点 & 轨迹折现图
  getLocationTrack(data: TrackRequestParams) {
    return this.http.post<TrackResponseData>('/location/track', data)
  }
  // 导出
  download(type: 0 | 1, options: Partial<RequestParams>, moduleName: string) {
    const params = Object.assign({}, options, {
      file_type: type,
      page: 1, // 不分页
      limit: 9999999
    })
    return this.http.downloadWithBlob('/location/history/export', params, moduleName)
  }
}
